module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0640.c6246957.jpg";